// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.listingcostandfee.FeeTimingSubType

export enum FeeTimingSubType {
  ANNUALLY = 'ANNUALLY',
  APPROVED_FUTURE_RESIDENT = 'APPROVED_FUTURE_RESIDENT',
  AT_APPLICATION = 'AT_APPLICATION',
  BI_MONTHLY = 'BI_MONTHLY',
  BI_WEEKLY = 'BI_WEEKLY',
  DAILY = 'DAILY',
  DURING = 'DURING',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  MOVE_IN = 'MOVE_IN',
  MOVE_OUT = 'MOVE_OUT',
  ONE_TIME_OTHER = 'ONE_TIME_OTHER',
  PAST_RESIDENT = 'PAST_RESIDENT',
  PRE_APPLICATION = 'PRE_APPLICATION',
  /**
   * @deprecated
   */
  PRE_MOVE_IN = 'PRE_MOVE_IN',
  QUARTERLY = 'QUARTERLY',
  RECURRING_OTHER = 'RECURRING_OTHER',
  RENEWAL = 'RENEWAL',
  SEASONAL = 'SEASONAL',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY',
  SEMI_MONTHLY = 'SEMI_MONTHLY',
  TRANSFER = 'TRANSFER',
  TRI_ANNUALLY = 'TRI_ANNUALLY',
  WEEKLY = 'WEEKLY',
}

export const FeeTimingSubType_values = [
  FeeTimingSubType.ANNUALLY,
  FeeTimingSubType.APPROVED_FUTURE_RESIDENT,
  FeeTimingSubType.AT_APPLICATION,
  FeeTimingSubType.BI_MONTHLY,
  FeeTimingSubType.BI_WEEKLY,
  FeeTimingSubType.DAILY,
  FeeTimingSubType.DURING,
  FeeTimingSubType.HOURLY,
  FeeTimingSubType.MONTHLY,
  FeeTimingSubType.MOVE_IN,
  FeeTimingSubType.MOVE_OUT,
  FeeTimingSubType.ONE_TIME_OTHER,
  FeeTimingSubType.PAST_RESIDENT,
  FeeTimingSubType.PRE_APPLICATION,
  FeeTimingSubType.PRE_MOVE_IN,
  FeeTimingSubType.QUARTERLY,
  FeeTimingSubType.RECURRING_OTHER,
  FeeTimingSubType.RENEWAL,
  FeeTimingSubType.SEASONAL,
  FeeTimingSubType.SEMI_ANNUALLY,
  FeeTimingSubType.SEMI_MONTHLY,
  FeeTimingSubType.TRANSFER,
  FeeTimingSubType.TRI_ANNUALLY,
  FeeTimingSubType.WEEKLY,
] as const;
